import ApiService, { IndexResponseBase } from '@/apis/apiService'
import type { Conversation, ConversationDetail } from '@/types/chat'

interface ConversationsIndexResponse extends IndexResponseBase {
  conversations: Conversation[]
}

const index = async (signal?: AbortSignal): Promise<ConversationsIndexResponse> => {
  const response = await ApiService.get<ConversationsIndexResponse>('/api/conversations', {
    signal,
  })
  return response.data
}

const show = async (id: string, signal?: AbortSignal): Promise<ConversationDetail> => {
  const response = await ApiService.get<ConversationDetail>(`/api/conversations/${id}`, { signal })
  return response.data
}

const destroy = async (id: string): Promise<void> => {
  await ApiService.delete(`/api/conversations/${id}`)
}

export default { index, show, destroy }
